import React from "react";
import "./Withdraw_bank_info.css";

function Withdraw_bank_info({ type }) {
  const isUSDT = type === 2;

  return (
    <section className="Withdraw_bank_info">
      <div className="withdraw_card">

        {/* Heading */}
        <div className="heading_text_holder">
          {isUSDT && (
            <div className="img_holder">
              <img
                src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                className="usdt_img"
                alt="usdt"
              />
            </div>
          )}
          {isUSDT ? "Select amount of USDT" : "Please enter the amount"}
        </div>

        {/* Amount Input */}
        <div className="amount_input">
          <span className="rupee">₹</span>
          <input type="text" placeholder="Please enter withdrawal amount" />
        </div>

        {/* USDT extra input */}
        {isUSDT && (
          <div className="amount_input">
            <span className="rupee">
              <img
                src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                className="usdt_img"
                alt="usdt"
              />
            </span>
            <input type="text" placeholder="Please enter USDT amount" />
          </div>
        )}

        {/* Balance */}
        <div className="balance_row">
          <p>
            Withdrawable balance <span className="orange">₹0.00</span>
          </p>
          <button className="all_btn">All</button>
        </div>

        {/* Button */}
        <button className="gray_btn">Withdraw</button>

        {/* Info */}
        <div className="Withdraw_deposite_bank_info">
          <div className="info_box">
            <p><span className="red">•</span> Need to bet <span className="red">₹2.33</span> to be able to withdraw</p>
            <p><span className="red">•</span> Withdraw time <span className="red">00:00-23:55</span></p>
            <p><span className="red">•</span> In day Remaining Withdrawal <span className="red">Times 3</span></p>
            <p><span className="red">•</span> Withdrawal amount range <span className="red">₹10.00 - ₹10,000,000.00</span></p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Withdraw_bank_info;